import { Aeronave } from './../../model/aeronave/aeronave';
import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';

import { GenericService } from '../generics/generic.service';
import { AutoRegisterService } from '../generics/servicesRegistry';

@Injectable({
  providedIn: 'root'
})

@AutoRegisterService()
export class AeronaveService extends GenericService<Aeronave>{
  constructor(http: HttpClient) { 
    super(http);
    super.initResource("aeronave")
  }
}
